import { dsClass } from '../../../common/constants/dsClasses.js';
import {
  customerServiceNumberLabelMsg,
  customerServiceNumberOpenLongMsg,
  customerServiceNumberPriceMsg,
  orderCouldNotBeProcessedMsg,
  t,
} from '../../../common/i18n/index.js';
import { DialogWrapper } from '../../DialogWrapper/DialogWrapper.js';

interface OrderSubmissionErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Error modal shown when order submission fails.
 * Displays customer service contact information.
 */
export const OrderSubmissionErrorModal = ({ isOpen, onClose }: OrderSubmissionErrorModalProps) => {
  if (!isOpen) {
    return null;
  }

  const errorMessage = t.MOF8(
    orderCouldNotBeProcessedMsg,
    customerServiceNumberLabelMsg,
    t.HQWV(customerServiceNumberOpenLongMsg),
    t.HQWW(customerServiceNumberPriceMsg)
  );

  return (
    <DialogWrapper
      header={t.V0VJ('Oops, something went wrong')}
      buttons={[
        {
          text: 'OK',
          onClick: onClose,
        },
      ]}
      onCloseDialog={onClose}
      closeable={true}
    >
      <p className={dsClass.PADDING_TOP_4}>{errorMessage}</p>
    </DialogWrapper>
  );
};
